import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const WorkspaceList = Loadable({ loader: () => import('./workspaceList'), loading: Loading });
const WorkspaceShow = Loadable({ loader: () => import('./workspaceShow'), loading: Loading });

export default { 
  list: WorkspaceList,
  show: WorkspaceShow,
};